import epicPng from './epic.png';
import Great from './Great';
import MilestoneTrophy from './MilestoneTrophy';
import Solid from './Solid';

/**
 * Artwork for the web Rate It module, ported verbatim from the mobile app
 * (`src/assets/tiri/rateit/`).
 *
 * Both SVG files are plain functions returning an SVG document as a string, with no React
 * Native imports at all — which is exactly why they copy across untouched, and why they must
 * stay that way. Render them with `html-react-parser`, the same way `components/Icon.js` renders
 * the app-wide icon registry.
 *
 * They are deliberately NOT registered in `src/assets/icons/`: `components/Icon.js` hard-codes
 * `width === height` on its wrapper, and the Great glyph is a 48x26 viewBox — it would render at
 * roughly half the height of the other two and read as a rendering bug. `RateItTierIcon`
 * normalises the three by HEIGHT instead, letting width follow each glyph's own ratio.
 */
/**
 * The three tier glyphs, and the one thing that differs between them.
 *
 * `solid` and `great` are vectors. `epic` is a RASTER — its Figma export is a 36x36 SVG whose
 * only content is a 1024x1024 base64 PNG painted through a `<pattern>`, which is ~133KB of
 * string for a 22px glyph and not really a vector at all. It ships as a white alpha mask
 * instead, tinted with a CSS `mask` (the direct analogue of React Native's `tintColor`).
 *
 * `RateItTierIcon` is the only file that reads `kind`; everything else asks for a rating, a size
 * and a colour.
 */
/**
 * The every-5-ratings badge. Not part of `RATE_IT_TIER_ART` because it is not a tier and not a
 * glyph: it ships its own disc and ring, and is rendered at one size by one component.
 */
export { MilestoneTrophy };

export const RATE_IT_TIER_ART = {
  solid: { kind: 'vector', xml: Solid, aspect: 20 / 20 },
  great: { kind: 'vector', xml: Great, aspect: 48 / 26 },
  // Square: the source ink measures 686x692, a 0.9% difference that is sub-pixel at icon sizes.
  epic: { kind: 'raster', src: epicPng, aspect: 1 }
};
